import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";
import { CausalLoopState, JobConfig, JobRun } from "../models/interfaces";
import { JobType } from "../constants/JobTypes";

// Initial State
const initialState: CausalLoopState = {
  jobConfigList: [],
  jobRunList: [],
  loading: false,
};

// Async Thunks
export const fetchJobConfigCausalLoop = createAsyncThunk<JobConfig[]>(
  "causalLoop/fetchJobConfig",
  async () => {
    const response = await axiosInstance.get(
      `/api/jobConfig/jobType/${JobType.CausalLoop}`
    );
    return response.data.items;
  }
);

export const fetchJobRunCausalLoop = createAsyncThunk<JobRun[]>(
  "causalLoop/fetchJobRun",
  async () => {
    const response = await axiosInstance.get(
      `/api/jobRun/jobType/${JobType.CausalLoop}`
    );
    return response.data.items;
  }
);

// Redux Slice
const causalLoopSlice = createSlice({
  name: "causalLoop",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobConfigCausalLoop.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchJobConfigCausalLoop.fulfilled,
        (state, action: PayloadAction<JobConfig[]>) => {
          state.jobConfigList = action.payload;
          state.loading = false;
        }
      )
      .addCase(fetchJobConfigCausalLoop.rejected, (state) => {
        state.loading = false;
      })
      .addCase(
        fetchJobRunCausalLoop.fulfilled,
        (state, action: PayloadAction<JobRun[]>) => {
          state.jobRunList = action.payload;
        }
      );
  },
});

export default causalLoopSlice.reducer;
